import { gsap, ScrollTrigger } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger);

class SliderControls {
  constructor() {
    this.slides = document.querySelectorAll('.js-slider__slide');
    this.slides__list = document.querySelector('.js-slider__wrapper');
    this.slides__inner = document.querySelector('.js-slider__inner');
    this.control_right = document.querySelector('.pagination__arrow--next');
    this.control_left = document.querySelector('.pagination__arrow--prev');
    this.style = this.slides__list.currentStyle || window.getComputedStyle(this.slides__list);
    this.paddingLeft = Math.round(parseFloat(this.style.paddingLeft));
    this.inner__style = this.slides__inner.currentStyle || window.getComputedStyle(this.slides__inner);
    this.inner__paddingLeft = Math.round(parseFloat(this.inner__style.paddingLeft));

    this.init();
  }
  init() {
    this.control_right.addEventListener('click', () => {
      const scrollPoint = this.getScrollPoint();
      this.next(scrollPoint);
    });

    this.control_left.addEventListener('click', () => {
      const scrollPoint = this.getScrollPoint();
      this.prev(scrollPoint);
    });

    this.slides__list.addEventListener('scroll', () => {
      const scrollPoint = this.getScrollPoint();
      const maxScrollLeft = this.slides__list.scrollWidth - this.slides__list.clientWidth;

      if (scrollPoint >= maxScrollLeft - this.paddingLeft - this.inner__paddingLeft) {
        this.control_right.classList.add('pagination__arrow--disabled');
      } else {
        this.control_right.classList.remove('pagination__arrow--disabled');
      }

      if (scrollPoint < (this.paddingLeft + this.inner__paddingLeft)) {
        this.control_left.classList.add('pagination__arrow--disabled');
      } else {
        this.control_left.classList.remove('pagination__arrow--disabled');
      }
    });
  }

  next(scrollPoint) {
    const possibleTargets = [];
    let target;
    this.slides.forEach(slide => {
      if (slide.offsetLeft > scrollPoint + this.inner__paddingLeft + this.paddingLeft) {
        possibleTargets.push((slide.offsetLeft));
      }
    });
    if (possibleTargets.length) {
      const smallest = possibleTargets.sort((a, b) => a - b);
      if (scrollPoint === 0) {
        // User hasn't scrolled yet so we need to set the target as the second array element
        target = smallest[0];
      } else {
        target = smallest[0];
      }
      this.slides__list.scrollTo({ top: 0, left: (target - this.inner__paddingLeft - this.paddingLeft), behavior: 'smooth' });
    }
  }

  prev(scrollPoint) {
    const possibleTargets = [];
    let target;
    this.slides.forEach(slide => {
      if (slide.offsetLeft - this.inner__paddingLeft - this.paddingLeft < scrollPoint) {
        possibleTargets.push(slide.offsetLeft);
      }
    });
    if (possibleTargets.length) {
      const greatest = possibleTargets.sort((a, b) => b - a);
      target = greatest[0];
      this.slides__list.scrollTo({ top: 0, left: (target - this.inner__paddingLeft - this.paddingLeft), behavior: 'smooth' });
    }
  }

  getScrollPoint() {
    return this.slides__list.scrollLeft;
  }
}

export default SliderControls;
